import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { Picture } from "@/components/wpl/image/src";
import { wacToken } from "@/libraries/design/foundations";

import { teamNamesMap, type TeamType } from "../../utils/paid-jira-ai-ffl";

import { messages } from "./messages";

const containerCss = css({
    position: "relative",
    margin: "0 auto",
    width: "100%",
    maxWidth: "61.688rem",
    marginBlockStart: "5.875rem"
});

const pictureCss = css({
    display: "block",
    width: "100%",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
        objectFit: "contain",
        width: "100%",
        height: "auto"
    }
});

const titleCss = css({
    fontFamily: token("font.family.brand.heading"), // Charlie Display
    fontWeight: 700,
    fontSize: "1.26rem",
    lineHeight: "2.1rem",
    color: wacToken("color.neutral.light1000"),
    position: "absolute",
    insetInlineStart: "5.558rem",
    insetBlockStart: "1.99rem"
});

export const PaidJiraAiJiraPreview = ({ teamType }: { teamType: TeamType }) => {
    const intl = useIntl();

    return (
        <div css={containerCss}>
            <Picture
                image={{
                    src: "https://dam-cdn.atl.orangelogic.com/CDNLink/AT12EIEC.webp",
                    alt: intl.formatMessage(messages.jiraAiPreview)
                }}
                css={pictureCss}
            />
            <div css={titleCss}>{teamNamesMap[teamType]}</div>
        </div>
    );
};
